const { CAMERA_ZOOM_MIN, CAMERA_ZOOM_MAX } = require('./OrbitalCamera');

const CAMERA_ZOOM_INCREMENT = 1;
const CAMERA_Y_PAN_INCREMENT = 0.5;
const CAMERA_Y_PAN_MIN = -0.4;
const CAMERA_Y_PAN_MAX = 0.5;

const onZoomIn = function() {
  this.camera.zoom = Math.min(
    this.camera.zoom + CAMERA_ZOOM_INCREMENT,
    CAMERA_ZOOM_MAX
  );
  this.camera.updateProjectionMatrix();
};

const onZoomOut = function() {
  this.camera.zoom = Math.max(
    this.camera.zoom - CAMERA_ZOOM_INCREMENT,
    CAMERA_ZOOM_MIN
  );
  this.camera.updateProjectionMatrix();
};

const onPanLeft = function() {
  const temp = this.camera.position.z;
  this.camera.position.z = -1 * this.camera.position.x;
  this.camera.position.x = temp;
};

const onPanUp = function() {
  this.camera.position.y = Math.max(
    CAMERA_Y_PAN_MIN,
    this.camera.position.y - CAMERA_Y_PAN_INCREMENT
  );
};

const onPanDown = function() {
  this.camera.position.y = Math.min(
    CAMERA_Y_PAN_MAX,
    this.camera.position.y + CAMERA_Y_PAN_INCREMENT
  );
};

const onPanRight = function() {
  const temp = this.camera.position.x;
  this.camera.position.x = -1 * this.camera.position.z;
  this.camera.position.z = temp;
};

const onResetView = function() {
  this.camera.resetPosition();
};

const onFullScreen = function() {
  const viewport = document.getElementById('webgl-viewport');
  viewport.requestFullscreen();
};

const onExitFullScreen = function() {
  document.exitFullscreen();
};

module.exports = {
  onZoomIn,
  onZoomOut,
  onPanLeft,
  onPanUp,
  onPanDown,
  onPanRight,
  onResetView,
  onFullScreen,
  onExitFullScreen
};
